import React, { useEffect, useState } from 'react';
import authApiService from '../../../services/authServices';
import Modal from "../../../utils/modalUtils";
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";



const ScheduleSeason = () => {
  const navigate = useNavigate();
  const [seasonData, setSeasonData] = useState({
    matchesRegularSeason: '4',
    playersPostSeason: '16'
  });
  const [searchParams] = useSearchParams();
  const MRId = searchParams.get("id");

  /**
   * Handles form submission for scheduling regular season
   * @param {Event} e - The form submit event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authApiService.post(`regularSchedule?seasonId=${MRId}`);
  
      if (response.code === 200) {
        Modal.fire({
          icon: "success",
          title: "Success",
          text: "Regular Season scheduled successfully!",
          confirmButtonText: "OK",
          confirmButtonColor: "#addd1e"
        }).then(() => {
          navigate("/carter/manageRegistration");
        });
      } else {
        Modal.fire({
          icon: "error",
          title: "Failed",
          text: "Something went wrong!",
          confirmButtonText: "OK",
          confirmButtonColor: "#addd1e"
        });
      }
    } catch (error) {
      console.error("Error scheduling season:", error);
      Modal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to schedule season.",
        confirmButtonText: "OK",
        confirmButtonColor: "#addd1e"
      });
    }
  };

    return (
      <div className="page-container col-sm-9">
        <h2 className='text-dark'>Current Registrants</h2>
        <table cellSpacing={0} id="registrantList" className="table" cellPadding={0}>
          <thead>
            <tr>
              <th className="sortable">
                Name
              </th>
            </tr>
          </thead>
        </table>
        <form
          id="scheduleSeason"
          method="post"
          action="scheduleSeason.html"
          onSubmit={handleSubmit}
        >
          <div style={{ margin: '0', padding: '0' }}>
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="seasonMatches" className="desc">
                Matches in Regular Season
              </label>
              <input
                id="regularSeasonMatches"
                name="regularSeasonMatches"
                className="text medium"
                type="text"
                defaultValue="4"
                value={seasonData.matchesRegularSeason}
                onChange={(e) => setSeasonData({
                  ...seasonData,
                  matchesRegularSeason: e.target.value
                })}
                maxLength={50}
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="postSeasonPlayers" className="desc">
                Players in Post Season
              </label>
              <select
                id="postSeasonPlayers"
                name="postSeasonPlayers"
                className="text medium"
                value={seasonData.playersPostSeason}
                onChange={(e) => setSeasonData({
                  ...seasonData,
                  playersPostSeason: parseInt(e.target.value)
                })}
              >
                <option value={16}>16</option>
                <option value={8}>8</option>
                <option value={4}>4</option>
                <option value={0}>0</option>
              </select>
            </div>
            <div style={{ marginBottom: '15px' }}>

              <button type='submit' className='green_btn' onClick={handleSubmit}>save</button>
              <button type="button" className="gray_btn" style={{ marginLeft: '5px' }}
                onClick={() => {
                  navigate("/carter/manageRegistration");
                }}>
                Cancle
              </button>

            </div>
          </div>
        </form>
      </div>
    );
  };

  export default ScheduleSeason;